module.exports = __webpack_public_path__ + "static/CHF-1-front-2014210c2adb40517e398cc15ebf1e1c.png";